import { instance, errorService, savePreviousData } from '@/services/api'
import { masterAPIs } from '@/services/authConstantsV1'
import {
  updateGridRecord,
  addGridRecord,
  updateRowStyle,
  updateConditionFactorGridRecord,
} from '@/services/grid'
import _ from 'lodash'
import {
  calculatePerimeterBuildingFootprint,
  calculateGridHeight,
  showNotification,
  evaluateQantity,
  convertCalculation,
} from '@/services/calculate'
import { validateNumber } from '@/services/config'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import InputEditor from '@/components/DynamicComponents/Renderers/inputEditor'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import SelectEditor from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import CalculationEditor from '@/components/DynamicComponents/Renderers/calculationEditor'
import TakeoffSelectEditor from '@/components/DynamicComponents/Renderers/takeoffSelectEditor'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import FactorEditor from '@/components/DynamicComponents/Renderers/factorEditor'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: [
    'propData',
    'tableId',
    'tenantSF',
    'isChange',
    'bankArea',
    'bankPerimeter',
    'areaWatch',
    'perimeterWatch',
    'dataForUpdateGrid',
    'conditionFactorList',
  ],
  data() {
    return {
      myScreen: this.propData.screen,
      data: [],
      redrawTable: false,
      loaderAdd: false,
      assetRelatedData: [],
      savePreviousData: savePreviousData,
      firstRowUpdateInfo: this.propData.constructionInfoData
        ? this.propData.constructionInfoData
        : null,
      addConstructionInfo: this.propData.constructionInfo,
      takeOff: this.propData['dropdownData'].takeoff,
      editableColumn: '',
      cacheData: [],
      loader: false,
      prevSearchKey: '',
      prevSearch: null,
      prevResultTakeoff: null,
      prevSearchKeyTakeOff: '',
      currentResult: null,
      openCreate: false,
      construction_Quality_Factor_Loader: false,
      condition_Factor_Loader: false,
      area_Loader: false,
      perimeter_Loader: false,
      editableIndex: null,
      loading: false,
      sortedData: [],
      formGeneral: {
        construction_Quality_Factor_Id: this.propData.firstRowValues
          ? this.propData.firstRowValues.constructionQualityFactorId
          : undefined,
        condition_Factor_Id: this.propData.firstRowValues
          ? this.propData.firstRowValues.conditionFactorId
          : undefined,
        area:
          this.propData.firstRowValues && this.propData.firstRowValues.tenantSF
            ? this.propData.firstRowValues.tenantSF
            : this.propData.firstRowValues.area,
        perimeter: this.propData.firstRowValues
          ? this.propData.firstRowValues.perimeter
          : undefined,
        label: this.propData.firstRowValues
          ? this.propData.firstRowValues.label
          : undefined,
        previousConditionFactorId: this.propData.firstRowValues
          ? this.propData.firstRowValues.conditionFactorId
          : undefined,
      },
      rulesformGeneral: {
        construction_Quality_Factor_Id: [
          {
            required: true,
            message: 'Please select construction quality factor',
            trigger: 'change',
          },
        ],
        condition_Factor_Id: [
          {
            required: true,
            message: 'Please select condition factor',
            trigger: 'change',
          },
        ],
        area: [
          {
            required: true,
            message: 'Please enter area',
            trigger: 'blur',
          },
        ],
        perimeter: [
          {
            required: true,
            message: 'Please enter perimeter',
            trigger: 'blur',
          },
        ],
        label: [
          {
            required: this.propData.screen === 'Grouping Bank',
            message: 'Please enter grouping',
            trigger: 'blur',
          },
        ],
      },
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: false,
        rowSelection: 'multiple',
        suppressScrollOnNewData: true,
        tooltipShowDelay: 0,
        rowDragManaged: true,
        defaultColDef: {
          sortable: true,
          editable: true,
          resizable: true,
          suppressMovable: true,
          singleClickEdit: true,
          menuTabs: ['filterMenuTab'],
        },
        rowClassRules: {
          // row style function
          lockedRow: function(params) {
            params.editable = false
            return params.data.isLocked
          },
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      tableParams: null,
      postSort: null,
      width: '100%',
      height:
        this.propData.screen === 'Grouping Bank'
          ? '430px'
          : this.propData.screen === 'Tenant Bank' ||
            this.propData.screen === 'Tenant Interior Grouping'
            ? '320px'
            : '270px',
      fieldLoader: false,
      fieldName: null,
      isAddContract: false,
      isAddCategory: false,
      changeIndex: undefined,
      selectedRowKeys: [],
      loaderDelete: false,
      isCalculationError: false,
      calculationData: this.propData.calculationData,
      takeoffs: [],
      loaderCopy: false,
      selectedRows: [],
      keys: [
        'additionalDescription',
        'takeoff',
        'calculation',
        'quantity',
        'multiplier',
        'conditionFactor',
      ],
      takeoffDetails: null,
      tableState: null,
      checked: false,
      isValidTakeoff: false,
    }
  },
  watch: {
    tenantSF() {
      this.formGeneral.perimeter = calculatePerimeterBuildingFootprint(
        this.tenantSF,
      )
      this.formGeneral.area = this.tenantSF
      this.loading = true
      this.getData(this.gridOptions)
    },
    bankArea() {
      this.formGeneral.area = this.bankArea
        ? this.bankArea
        : this.formGeneral.area
      this.getData(this.gridOptions)
    },
    bankPerimeter() {
      this.formGeneral.perimeter = this.bankPerimeter
        ? this.bankPerimeter
        : this.formGeneral.perimeter
      this.getData(this.gridOptions)
    },
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      this.sortedData = []
      for (let i = 0; i < rowNodes.length; i++) {
        if (rowNodes[i].data.categoryCode) {
          rowNodes[i].data.categoryCode = Number(rowNodes[i].data.categoryCode)
        }
        this.sortedData.push(rowNodes[i].data)
      }
      this.data = [...this.sortedData]
    }
  },
  created() {
    this.$root.$on('deleteRecord', this.deleteRecord)
    this.$root.$on('handleChange', this.handleChange)
  },
  mounted() {
    this.loadingConfig()
    this.gridColumnApi = this.gridOptions.columnApi
    this.$root.$on('showLoader', this.showLoader)
    window.addEventListener('resize', this.getWindowSize)
    if (this.propData.firstRowValues.tenantSF) {
      this.propData.firstRowValues[
        'area'
      ] = this.propData.firstRowValues.tenantSF
    }
  },
  beforeDestroy() {
    this.$root.$off('handleChange')
    this.$root.$off('deleteRecord')
    this.data = []
    this.$root.$off('showLoader')
    this.$root.$off('displayDropdown')
    this.$root.$off('setTenantData')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onModelUpdated() {
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length === 0
      ) {
        this.gridOptions.api.showNoRowsOverlay()
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length > 0
      ) {
        this.gridOptions.api.hideOverlay()
      }
    },

    getData(params) {
      this.propData.rows.forEach(element => {
        if (element.calculation) {
          element.formula = convertCalculation(
            element.calculation,
            this.propData,
            this.calculationData,
            this.propData.dropdownData.calculation,
          )
        }
        element.area =
          this.propData.firstRowValues && this.propData.firstRowValues.area
            ? this.propData.firstRowValues.area
            : 0
      })
      const displayColumns = this.refreshColumns()
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      params.api.setRowData(this.propData.rows)
      this.isValidTakeoff = this.propData.rows.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      if (this.propData.screen === 'Tenant Interior Grouping') {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'display',
              hide: !!this.propData.firstRowValues.bankInterioGroupingId,
            },
          ],
        })
      } else {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'display',
              hide: false,
            },
          ],
        })
      }
      if (this.tableId) {
        this.height = '300px'
      } else {
        this.height = calculateGridHeight(this.propData.tableId)
      }
    },

    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        inputCellEditor: InputEditor,
        customFilter: CustomFilter,
        selectEditor: SelectEditor,
        costPriceCellRenderer: CurrencyRenderer,
        inputNumberEditor: InputNumberEditor,
        toolTipRenderer: ToolTipRenderer,
        calculationEditor: CalculationEditor,
        takeoffSelectEditor: TakeoffSelectEditor,
        textEditor: TextEditor,
        factorEditor: FactorEditor,
      }
    },

    onUpdateConditionFactor(fieldName, value, field) {
      window.previousValue = this.formGeneral.previousConditionFactorId
      var isPresent = this.data.some(
        e => e.conditionFactorId !== window.previousValue,
      )
      if (isPresent) {
        var that = this
        this.$confirm({
          title: `Do you want to change overridden condition factor?`,
          content: h => (
            <div>
              <p>This action will change the overridden condition factor.</p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.handleChangeConstruction(fieldName, value, field)
          },
          onCancel() {
            that.formGeneral.condition_Factor_Id = window.previousValue
          },
        })
      } else {
        this.handleChangeConstruction(fieldName, value, field)
      }
    },

    handleChangeConstruction(FieldName, value, type) {
      this.fieldName = FieldName
      let url = null
      let request = {}
      const currentValue = !value ? '' : value
      const previousValue = !window.previousValue ? '' : window.previousValue
      if (previousValue.toString() !== currentValue.toString()) {
        let isValid = true
        switch (this.propData.screen) {
          case 'Grouping Bank':
            url = masterAPIs.groupingBank.details(this.$route.params.id)
            break
          case 'Tenant Bank':
            url = masterAPIs.tenantBank.details(this.$route.params.id)
            break
          case 'Tenant Interior Grouping':
            url = masterAPIs.tenantBank.grouping.takeoff.list(
              this.propData.firstRowValues.id,
              this.$route.params.id,
            )
            if (this.fieldName === 'label' && !currentValue) {
              showNotification('error', 'Grouping', 'Please enter grouping!')
              this.fieldLoader = false
              return
            }
            break
          default:
            break
        }
        switch (FieldName) {
          case 'area':
            isValid = validateNumber(value, FieldName, 'Area')
            if (isValid) {
              this.$root.$emit('showDisplayLoader', true, true)
              request = {
                area: value || null,
              }
              if (!this.propData.showArea) {
                this.formGeneral.perimeter = calculatePerimeterBuildingFootprint(
                  value,
                )
                if (this.propData.screen === 'Tenant Bank') {
                  Object.assign(request, {
                    Perimeter_Building_Footprint: this.formGeneral.perimeter,
                  })
                } else {
                  Object.assign(request, {
                    perimeter: this.formGeneral.perimeter,
                  })
                }
              }
            } else {
              this.formGeneral.area = previousValue
            }
            break
          case 'label':
            request = {
              label: value,
            }
            break
          case 'constructionQualityFactorId':
            request = {
              constructionQualityFactorId: value,
            }
            break
          case 'conditionFactorId':
            this.loading = true
            request = {
              conditionFactorId: value,
            }
            this.fieldLoader = true
            this.updateBankDetails(url, request)
            break
          case 'perimeter':
            isValid = validateNumber(value, FieldName, 'Perimeter')
            if (isValid) {
              this.$root.$emit('showDisplayLoader', true, true)
              if (this.propData.screen === 'Tenant Bank') {
                this.$emit('updatePerimeter', FieldName)
              }
              request = {
                perimeter: value || null,
              }
            } else {
              this.formGeneral.perimeter = previousValue
            }
            break
          default:
            break
        }
        if (isValid) {
          this.fieldLoader = true
          this.updateBankDetails(url, request)
        }
      }
    },

    updateBankDetails(url, request) {
      instance
        .patch(url, request)
        .then(res => {
          this.loading = false
          this.fieldLoader = false
          this.$emit('updateBasic', request)
          if (request.conditionFactorId) {
            this.formGeneral.previousConditionFactorId =
              request.conditionFactorId
            this.resetGridConditionFactor(request)
          }
        })
        .catch(err => {
          this.loading = false
          this.fieldLoader = false
          errorService(err)
        })
    },

    handleChange(value, record, key, index, takeoffData, data, keyCode) {
      let url = null
      let isValid = true
      this.changeIndex = this.data.findIndex(val => val.id === record.id)
      if (this.changeIndex > -1) {
        const newData = [...this.data]
        switch (this.propData.screen) {
          case 'Grouping Bank':
            url = masterAPIs.groupingBank.takeoff.update(record.id)
            break
          case 'Tenant Bank':
          case 'Tenant Interior Grouping':
            url = masterAPIs.tenantBank.takeoff.update(record.id)
            break
          default:
        }
        const currentValue =
          value === 0 ? value.toString() : !value ? '' : value
        const previousValue = !window.previousValue ? '' : window.previousValue
        if (
          (currentValue !== null &&
            previousValue.toString() !== currentValue.toString()) ||
          key === 'calculation'
        ) {
          let request = {}
          switch (key) {
            case 'calculation':
              newData[index].formula = record.formula
              request = {
                calculation: value,
                quantity:
                  evaluateQantity(record.formula) > 0
                    ? evaluateQantity(record.formula)
                    : null,
                isCalculationMatched: true,
              }
              break
            case 'takeoff':
              this.takeoffDetails = { ...record }
              request = {
                takeoffId: takeoffData.id,
                takeoffGroupingId: takeoffData.takeoffGroupingId,
                contractId: takeoffData.contractId,
                categoryId: takeoffData.categoryCodeId,
                unitId: takeoffData.unitId,
                unitCost: takeoffData.unitCost,
                source: takeoffData.source,
              }
              break
            case 'multiplier':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value || 0, key, 'Multiplier')
              if (isValid) {
                request = {
                  [key]: value || null,
                }
              }
              break
            case 'quantity':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value, key, 'Quantity')
              if (isValid) {
                let isCalculationMatched = false
                if (
                  record.formula &&
                  value &&
                  evaluateQantity(record.formula) === Number(value)
                ) {
                  isCalculationMatched = true
                }
                request = {
                  [key]: value > 0 ? value : null,
                  isCalculationMatched: isCalculationMatched,
                }
              }
              break
            case 'conditionFactor':
              isValid = validateNumber(
                value,
                'conditionFactor',
                'Condition Factor',
              )
              if (isValid) {
                const factor = this.conditionFactorList.find(
                  i => i.value === value,
                )
                this.takeoffDetails = { ...record }
                request = {
                  [key]: value || null,
                  conditionFactorId: factor.id,
                }
              }
              break
            default:
              this.takeoffDetails = { ...record }
              request = {
                [key]: value || null,
              }
              break
          }
          if (isValid) {
            this.loading = true
            instance
              .patch(`${url}`, request)
              .then(response => {
                newData[index] = _.get(response.data, 'result', undefined)
                if (newData[index]) {
                  if (record.formula) {
                    newData[index].formula = record.formula
                  }
                  newData[index].area = this.propData.firstRowValues.area
                  if (
                    key === 'calculation' &&
                    evaluateQantity(record.formula) < 0
                  ) {
                    newData[index].quantity = null
                  }
                }
                this.data = [...newData]
                this.gridOptions.api.redrawRows()
                const itemsToUpdate = updateGridRecord(
                  this.gridOptions,
                  record,
                  newData[index],
                )
                this.gridOptions.api.applyTransaction({
                  update: itemsToUpdate,
                })
                this.gridOptions.api.redrawRows()
                this.isValidTakeoff = this.data.some(
                  i =>
                    typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
                )
                if (this.checked) {
                  this.sortTakeoffs(this.isValidTakeoff)
                }
                this.loading = false
                this.takeoffDetails = null
                const focusedCell = this.gridOptions.api.getFocusedCell()
                const rowIndex = this.data.findIndex(
                  val => val.id === record.id,
                )
                if (focusedCell) {
                  let colKey
                  switch (key) {
                    case 'additionalDescription':
                      colKey = 'takeoff'
                      break
                    case 'takeoff':
                      colKey = 'calculation'
                      break
                    case 'calculation':
                      colKey = 'quantity'
                      break
                    case 'quantity':
                      colKey = 'unit'
                      break
                    case 'unit':
                      colKey = 'unitCost'
                      break
                    case 'unitCost':
                      colKey = 'conditionFactor'
                      break
                    case 'conditionFactor':
                      colKey = 'multiplier'
                      break
                    case 'multiplier':
                      if (this.changeIndex === this.data.length - 1) {
                        if (keyCode === 9) {
                          this.addRecord()
                        }
                      } else {
                        this.gridOptions.api.setFocusedCell(
                          focusedCell.rowIndex,
                          focusedCell.column.colId,
                        )
                        this.gridOptions.api.startEditingCell({
                          rowIndex: focusedCell.rowIndex,
                          colKey: focusedCell.column.colId,
                        })
                      }
                      break
                    default:
                      break
                  }
                  if (key !== 'multiplier') {
                    if (rowIndex > -1) {
                      this.gridOptions.api.setFocusedCell(rowIndex, colKey)
                      this.gridOptions.api.startEditingCell({
                        rowIndex: rowIndex,
                        colKey: colKey,
                      })
                    }
                  }
                }
                this.$emit(
                  'updateTakeOff',
                  this.data,
                  false,
                  this.propData.firstRowValues.id,
                  !this.isValidTakeoff,
                )
              })
              .catch(err => {
                this.loading = false
                this.resetRowData(index)
                this.$emit(
                  'updateTakeOff',
                  this.data,
                  false,
                  this.propData.firstRowValues.id,
                )
                errorService(err)
              })
          } else {
            this.resetRowData(index)
          }
        } else {
          if (
            this.changeIndex === this.data.length - 1 &&
            key === 'multiplier'
          ) {
            if (keyCode === 9) {
              this.addRecord()
            }
          }
        }
      }
    },

    tabToNextCell(params) {
      const previousCell = params.previousCellPosition
      const nextCellPosition = params.nextCellPosition
      let result = null
      const isTab = true
      if (isTab && nextCellPosition) {
        result = {
          rowIndex: nextCellPosition.rowIndex,
          column: nextCellPosition.column,
          floating: previousCell.floating,
        }
        return result
      }
    },

    deleteRecord(index, id) {
      this.loading = false
      const findIndex = this.data.findIndex(val => val.id === id)
      if (findIndex > -1) {
        this.gridOptions.api.applyTransaction({
          remove: [this.data[findIndex]],
        })
      }
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      if (this.checked) {
        this.sortTakeoffs(this.isValidTakeoff)
      }
      this.$emit(
        'updateTakeOff',
        this.data,
        false,
        this.propData.firstRowValues.id,
        !this.isValidTakeoff,
      )
      this.selectedRowKeys = []
      this.selectedRows = []
    },

    deleteAllRecord() {
      var that = this
      this.$confirm({
        title: `Are you sure want to delete records?`,
        content: h => (
          <div style="color:red">
            <p>This action will delete all information related these rows.</p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
      })
    },

    confirmDelete() {
      const url = this.propData.columns[this.propData.columns.length - 1]
        .cellRendererParams.url
      this.loaderDelete = true
      instance
        .patch(url, this.selectedRowKeys)
        .then(response => {
          this.loaderDelete = false
          this.gridOptions.api.applyTransaction({
            remove: this.selectedRows,
          })
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          this.isValidTakeoff = this.data.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (this.checked) {
            this.sortTakeoffs(this.isValidTakeoff)
          }
          this.$emit(
            'updateTakeOff',
            this.data,
            false,
            this.propData.firstRowValues.id,
            !this.isValidTakeoff,
          )
          this.selectedRowKeys = []
          this.selectedRows = []
        })
        .catch(err => {
          errorService(err)
        })
    },

    addRecord() {
      this.loaderAdd = true
      let url = null
      let newData = [...this.data]
      switch (this.myScreen) {
        case 'Grouping Bank':
          url = masterAPIs.groupingBank.takeoff.add(this.$route.params.id)
          break
        case 'Tenant Bank':
          url = masterAPIs.tenantBank.takeoff.add(this.$route.params.id)
          break
        case 'Tenant Interior Grouping':
          url = masterAPIs.tenantBank.grouping.takeoff.add(
            this.propData.firstRowValues.id,
            this.$route.params.id,
          )
          break
      }
      instance
        .post(url)
        .then(response => {
          newData = newData.concat(_.get(response.data, 'result', []))
          newData.map(element => {
            element['area'] = this.formGeneral.area
            return element
          })
          this.data = [...newData]
          this.gridOptions.api.redrawRows()
          var itemsToAdd = addGridRecord(_.get(response.data, 'result', {}))
          itemsToAdd.forEach(e => {
            e.isValidTakeoff = true
          })
          this.gridOptions.api.applyTransaction({
            add: itemsToAdd,
          })
          const result = _.get(response.data, 'result', [])
          const indexOfNewRecord = this.data.findIndex(
            val => val.id === result.id,
          )
          this.gridOptions.api.setFocusedCell(indexOfNewRecord, 'takeoff')
          this.gridOptions.api.startEditingCell({
            rowIndex: indexOfNewRecord,
            colKey: 'takeoff',
          })
          if (this.tableId) {
            this.height = '300px'
          } else {
            this.height = calculateGridHeight(this.propData.tableId)
          }
          this.isValidTakeoff = this.data.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (this.checked) {
            this.sortTakeoffs(this.isValidTakeoff)
          }
          this.$emit(
            'updateTakeOff',
            this.data,
            false,
            this.propData.firstRowValues.id,
            !this.isValidTakeoff,
          )
          this.loaderAdd = false
        })
        .catch(err => {
          this.loaderAdd = false
          errorService(err)
        })
    },

    onCellValueChanged(event) {
      if (event.colDef.field === 'calculation') {
        if (event.value) {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.calculation = event.oldValue
          if (event.oldValue) {
            this.takeoffDetails.formula = convertCalculation(
              event.oldValue,
              this.propData,
              this.calculationData,
              this.propData['dropdownData'].calculation,
            )
          }
          const calculation = convertCalculation(
            event.value,
            this.propData,
            this.calculationData,
            this.propData['dropdownData'].calculation,
          )
          event.data['formula'] = calculation
          const reg = /^[0-9. ()]+([-+*/()]+[ -+()]?[ 0-9.()]+)*$/
          if (!reg.test(calculation)) {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.resetRowData(event.rowIndex)
          } else if (evaluateQantity(event.data['formula']) === 'Error') {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.resetRowData(event.rowIndex)
          } else {
            this.handleChange(
              event.value,
              event.data,
              event.colDef.field,
              event.rowIndex,
              event.colDef.cellRendererParams.dataType,
              null,
              null,
              event.keyCode,
            )
          }
        } else {
          event.data['formula'] = undefined
          this.handleChange(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            event.colDef.cellRendererParams.dataType,
            null,
            null,
            event.keyCode,
          )
        }
      } else if (event.colDef.field === 'conditionFactor') {
        this.takeoffDetails = { ...event.data }
        this.takeoffDetails.conditionFactor = event.oldValue
        const isValid = validateNumber(
          event.value,
          'conditionFactor',
          'Condition Factor',
        )
        if (isValid) {
          window.previousValue = event.oldValue
          let factor = this.conditionFactorList.find(
            i => i.value === event.value,
          )
          if (!factor) {
            factor = {
              id: event.data.conditionFactorId,
            }
          }
          this.handleChange(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            event.colDef.cellRendererParams.dataType,
            null,
            null,
            event.keyCode,
          )
        } else {
          this.resetRowData(event.rowIndex)
        }
      }
    },

    showLoader(flag) {
      this.loading = flag
    },

    getWindowSize() {
      if (this.tableId) {
        this.height = '300px'
      } else {
        this.height = calculateGridHeight(this.propData.tableId, false)
      }
      this.gridOptions.api.sizeColumnsToFit()
    },

    sortChanged(node) {
      this.tableState = this.gridOptions.columnApi.getColumnState()
      const isSortApplied = this.tableState
        .filter(
          i =>
            i.colId !== 'action' &&
            i.colId !== 'display' &&
            i.colId !== '0' &&
            i.colId !== 'isLocked',
        )
        .some(element => element.sort)
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'display',
            hide:
              this.propData.firstRowValues &&
              this.propData.firstRowValues.bankInterioGroupingId
                ? true
                : isSortApplied,
          },
        ],
      })
      let newData = [...this.data]
      newData = this.sortedData
      this.data = newData
      this.$emit(
        'updateTakeOff',
        this.data,
        false,
        this.propData.firstRowValues.id,
      )
    },

    gridSizeChanged(e) {
      this.gridOptions.api.sizeColumnsToFit()
    },

    setActiveRow(res) {
      const result = _.get(res.data, 'result', [])
      const indexOfNewRecord = this.data.findIndex(val => val.id === result.id)
      this.gridOptions.api.setFocusedCell(indexOfNewRecord, 'takeoff')
      this.gridOptions.api.startEditingCell({
        rowIndex: indexOfNewRecord,
        colKey: 'takeoff',
      })
    },

    cloneTakeoff() {
      this.loaderCopy = true
      let url = null
      let newData = [...this.data]
      switch (this.propData.screen) {
        case 'Grouping Bank':
          url = masterAPIs.groupingBank.takeoff.clone(this.$route.params.id)
          break
        case 'Tenant Bank':
          url = masterAPIs.tenantBank.takeoff.clone(this.$route.params.id)
          break
        case 'Tenant Interior Grouping':
          url = masterAPIs.tenantBank.grouping.takeoff.clone(
            this.propData.firstRowValues.id,
            this.$route.params.id,
          )
          break
        default:
          break
      }
      const constData = [...this.propData.rows]
      instance
        .put(url, this.selectedRowKeys)
        .then(response => {
          showNotification(
            'success',
            'Clone',
            _.get(response.data, 'message', null),
          )
          _.get(response.data, 'result', []).forEach(element => {
            if (element.calculation) {
              element.formula = convertCalculation(
                element.calculation,
                this.propData,
                this.calculationData,
                this.propData.dropdownData.calculation,
              )
              if (evaluateQantity(element.formula) < 0) {
                element.quantity = null
              }
            }
            element.area =
              this.propData.firstRowValues && this.propData.firstRowValues.area
                ? this.propData.firstRowValues.area
                : 0
          })
          newData = newData.concat(_.get(response.data, 'result', []))
          this.loading = false
          this.loaderCopy = false
          this.data = [...newData]
          this.selectedRowKeys = []
          this.gridOptions.api.applyTransaction({
            add: _.get(response.data, 'result', []),
          })
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          this.isValidTakeoff = this.data.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (this.checked) {
            this.sortTakeoffs(this.isValidTakeoff)
          }
          this.$emit(
            'updateTakeOff',
            this.data,
            false,
            this.propData.firstRowValues.id,
            !this.isValidTakeoff,
          )
        })
        .catch(err => {
          this.loading = false
          this.loaderCopy = false
          this.$emit(
            'updateTakeOff',
            constData,
            false,
            this.propData.firstRowValues.id,
          )
          errorService(err)
        })
    },

    refreshColumns() {
      const columns = JSON.stringify(this.propData.columns)
      const displayColumns = JSON.parse(columns)
      displayColumns.map(col => {
        let align = ''
        if (col.cellStyle) {
          align = col.cellStyle.textAlign
        }
        if (col.field !== 'action') {
          col.cellStyle = param => updateRowStyle(param, col.field, align)
        }
        if (col.headerName !== 'Action' && col.headerName !== '') {
          col.menuTabs = this.checked ? [] : ['filterMenuTab']
          col.sortable = !this.checked
          col.filter = 'customFilter'
        }
        if (this.propData) {
          if (this.keys.includes(col.field)) {
            col.editable = params => {
              return true
            }
          } else {
            col.editable = params => {
              return false
            }
          }
        } else {
          col.editable = params => {
            return col.field !== 'action' && !params.data.isLocked
          }
        }
      })

      return displayColumns
    },

    resetRowData(index) {
      const newData = [...this.data]
      if (newData[index]) {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
        newData[index].area = this.propData.firstRowValues.area
      }
      newData[index].quantity = this.takeoffDetails.quantity
      newData[index] = this.takeoffDetails
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.takeoffDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.takeoffDetails = null
    },

    onRowDragEnd(e) {
      this.loading = true
      const request = []
      this.data.forEach((i, index) => {
        request.push({
          id: i.id,
          sequence: index + 1,
        })
      })
      this.reorder(request)
    },

    onRowDragLeave(e) {
      this.onRowDragEnd(e)
    },

    reorder(request) {
      let url
      switch (this.propData.screen) {
        case 'Grouping Bank':
          url = masterAPIs.groupingBank.takeoff.reorder
          break
        case 'Tenant Bank':
        case 'Tenant Interior Grouping':
          url = masterAPIs.tenantBank.takeoff.reorder
          break
        default:
          break
      }
      instance
        .patch(url, request)
        .then(response => {
          this.selectedRowKeys = []
          this.gridOptions.api.deselectAll()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    getGridData() {
      const url = masterAPIs.tenantBank.grouping.takeoff.list(
        this.dataForUpdate.id,
        this.dataForUpdate.projectId,
      )
      instance.get(url).then(res => {
        const result = _.get(res.data, 'result', [])
        this.formGeneral.area = result.area
        this.formGeneral.perimeter = result.perimeter
        this.gridOptions.api.setRowData(result.takeoffs)
      })
    },

    resetGridConditionFactor(request) {
      const factor = this.conditionFactorList.find(
        i => i.id === request.conditionFactorId,
      )
      const itemsToUpdate = updateConditionFactorGridRecord(this.gridOptions, {
        conditionFactorId: request.conditionFactorId,
        ConditionFactorValue: factor.value,
      })
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
    },

    sortTakeoffs(value) {
      this.checked = value
      let newData = [...this.data]
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
      if (value) {
        newData = _.orderBy(newData, ['isValidTakeoff'], ['asc'])
        this.data = newData
        this.gridOptions.api.setRowData(this.data)
      } else {
        newData = _.orderBy(newData, ['sequence'], ['asc'])
        this.data = newData
        this.gridOptions.api.setRowData(this.data)
      }
      const displayColumns = this.refreshColumns()
      this.gridOptions.api.setColumnDefs(displayColumns)
      this.gridOptions.api.sizeColumnsToFit()
      if (this.propData.screen === 'Tenant Interior Grouping') {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'display',
              hide: true,
            },
          ],
        })
      } else {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'display',
              hide: value,
            },
          ],
        })
      }
    },

    filterChanged() {
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      switch (this.propData.screen) {
        case 'Tenant Bank':
        case 'Tenant Interior Grouping':
          this.$emit(
            'checkValidTab',
            this.propData.firstRowValues.id,
            !this.isValidTakeoff,
          )
          break
        default:
      }
    },
  },
}
